<template>
    <svg
        width="660"
        height="537"
        viewBox="0 0 660 537"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            x="287"
            y="58"
            font-family="Inter"
            font-weight="700"
            font-size="34"
            fill="var(--et-colors-text)"
        >
            FAQs
        </text>
        <text
            x="220"
            y="95"
            font-family="Inter"
            font-weight="500"
            font-size="15"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        >
            Can not find answer? Contact us
        </text>
        <path
            d="M373.367 99H451.128V99.8H373.367V99Z"
            fill="var(--et-colors-text)"
            fill-opacity="0.8"
        />
        <g>
            <rect
                x="12"
                y="129"
                width="636"
                height="106"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="36"
                y="169"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Will I receive a VAT invoice?
            </text>
            <rect
                x="330"
                y="153"
                width="294"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="169"
                width="184"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="185"
                width="208"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="201"
                width="114"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="12"
                y="243"
                width="636"
                height="78"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="36"
                y="284"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Can I return the purchased product?
            </text>
            <rect
                x="330"
                y="267"
                width="294"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="283"
                width="85"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="12"
                y="329"
                width="636"
                height="90"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="36"
                y="369"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                How do I get the source file?
            </text>
            <rect
                x="330"
                y="353"
                width="294"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="369"
                width="179"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="385"
                width="199"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="12"
                y="427"
                width="636"
                height="90"
                rx="12"
                fill="var(--et-colors-card-background)"
            />
            <text
                x="36"
                y="465"
                font-family="Inter"
                font-weight="600"
                font-size="14"
                fill="var(--et-colors-card-text)"
            >
                Where I can get help?
            </text>
            <rect
                x="330"
                y="451"
                width="294"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="467"
                width="248"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
            <rect
                x="330"
                y="483"
                width="182"
                height="10"
                rx="5"
                fill="var(--et-colors-card-text)"
                fill-opacity="0.15"
            />
        </g>
    </svg>
</template>
